import { render, staticRenderFns } from "./view2.vue?vue&type=template&id=f4521144&scoped=true&"
import script from "./view2.vue?vue&type=script&lang=js&"
export * from "./view2.vue?vue&type=script&lang=js&"
import style0 from "./view2.vue?vue&type=style&index=0&id=f4521144&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4521144",
  null
  
)

export default component.exports